import React from "react";
import { Button } from "@altimateai/lego";
import { IconPlayerStopFilled } from "@tabler/icons-react";
import { useCancelGeneration } from "../../hooks/useCancelGeneration";

export const CancelGenerationButton: React.FC = () => {
  const cancelGeneration = useCancelGeneration();

  return (
    <Button
      variant="destructive"
      size="icon"
      className="!al-h-9 al-bg-red-100 hover:al-bg-red-200"
      onClick={() => cancelGeneration("user_stop")}
      aria-label="Cancel generation"
      title="Cancel generation"
    >
      <IconPlayerStopFilled className="!al-h-6 !al-w-6 al-text-[#ef4444]" />
    </Button>
  );
};
